import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';

import { IndustryDefaultProvider, IndustryProvider } from './industry.provider';
import { FirebaseToken } from '../../app/core/firebase.module';
import { Firestore } from 'firebase/firestore';
import { GetIndustriesInteractor } from './domain/interactors/get-industries.interactor';

@NgModule({
  providers: angularProvidersBuilder({
    provide: IndustryProvider,
    deps: [FirebaseToken.Firestore],
    useFactory: (firestore: Firestore) => new IndustryDefaultProvider(firestore),
  })
    .add(GetIndustriesInteractor, (p) => p.provideGetIndustries())
    .build(),
})
export class IndustryProviderModule {}
